import styled from 'styled-components';

export {
  Button,
  Text,
  OrderHistoryMain,
  OrderHistoryDataMain,
  OrderHistoryTimestamp,
  OrderHistoryAction,
  FieldWrapper,
  ConfirmationContainer,
  ConfirmationMessage,
} from '../../dashboardCommon/components/css';

export const AttachmentContainer = styled.div`
  display: flex;
  border: 1px solid #e2e2e2;
  padding: 12px 14px;
  justify-content: space-between;
`;

export const FieldTitle = styled.h3`
  font-weight: bold;
  color: #000;
`;
